module.exports = __webpack_public_path__ + "static/media/wabusd-busd plp.4d91b8fa.png";